import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    app_role_home: "",
    email_home: "",
};

const homeTabSlicer = createSlice({
    name: "homeTab",
    initialState,
    reducers: {
        setAppRoleHome: (state, action) => ({
            ...state,
            app_role_home: action.payload,
        }),
        setEmailHome: (state, action) => ({
            ...state,
            email_home: action.payload
        }),
    }
})

export const {
    setAppRoleHome,
    setEmailHome,
} = homeTabSlicer.actions;

export default homeTabSlicer.reducer;